import FullScreenModalProvider from '../shared_components/FullScreenModalContext'
import BottomDrawerProvider from './BottomDrawerContext'
import ConfirmModalProvider from '../shared_components/ConfirmModalContext'
import OtpContextProvider from '../shared-hooks/OtpContext'
import UserInfoContextProvider from './UserInfoContext'
import { AntdProvider } from '../shared_components/AntdProvider'
import { WebViewBreakPoint } from '../shared-constants/webViewBreakPoints'
import HomeContextProvider from './HomeContext'
import GoogleTagManager from '../shared_components/GoogleTagManager'

export const BaseContext = ({ children }) => {

  return (
    <WebViewBreakPoint>
      {import.meta.env.VITE_MAIN_WEB_URL === 'https://web.shahrzaad.city' && (
        <GoogleTagManager />
      )}
      <HomeContextProvider>
        <AntdProvider>
          <OtpContextProvider>
            <FullScreenModalProvider>
              <BottomDrawerProvider>
                <ConfirmModalProvider>
                  <UserInfoContextProvider>{children}</UserInfoContextProvider>
                </ConfirmModalProvider>
              </BottomDrawerProvider>
            </FullScreenModalProvider>
          </OtpContextProvider>
        </AntdProvider>
      </HomeContextProvider>
    </WebViewBreakPoint>
  )
}
